export default "__VITE_ASSET__DGPtD$pc__"